import React, { useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Footer from "examples/Footer";
import PageNavbar from "components/PageNavbar";
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import Card from "@mui/material/Card";
import { Grid, ToggleButtonGroup, ToggleButton } from "@mui/material";
import { IoPersonOutline, IoVideocam } from "react-icons/io5";

// Configure the external server URL
const IFRAME_URL = "https://falldetection.hallix.ai/";

function FallDetection() {
  const [viewMode, setViewMode] = useState("live");

  const handleViewChange = (event, newView) => {
    if (newView !== null) {
      setViewMode(newView);
    }
  };

  return (
    <DashboardLayout>
      <PageNavbar />
      <VuiBox py={3}>
        <VuiBox mb={3}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Card
                sx={{
                  height: "100%",
                  background: "linear-gradient(127.09deg, rgba(6, 11, 40, 0.94) 19.41%, rgba(10, 14, 35, 0.49) 76.65%)",
                  backdropFilter: "blur(120px)",
                  border: "2px solid rgba(255, 255, 255, 0.125)",
                  borderRadius: "20px",
                  padding: "20px",
                }}
              >
                {/* Header with Toggle */}
                <VuiBox display="flex" alignItems="center" justifyContent="space-between" mb={3} flexWrap="wrap" gap={2}>
                  <VuiBox display="flex" alignItems="center">
                    <VuiBox
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      sx={{
                        background: "linear-gradient(97.89deg, #0075ff, #0075ff)",
                        width: "50px",
                        height: "50px",
                        borderRadius: "12px",
                        marginRight: "15px",
                        transition: "all 0.3s ease",
                      }}
                    >
                      {viewMode === "live" ? (
                        <IoPersonOutline size="24px" color="white" />
                      ) : (
                        <IoVideocam size="24px" color="white" />
                      )}
                    </VuiBox>
                    <VuiBox>
                      <VuiTypography variant="h4" color="white" fontWeight="bold">
                        {viewMode === "live" ? "Fall Detection System" : "System Demo"}
                      </VuiTypography>
                      <VuiTypography variant="button" color="text" fontWeight="regular">
                        {viewMode === "live" 
                          ? "AI-Powered Fall Detection with Face Recognition"
                          : "Watch Fall Detection in Action"}
                      </VuiTypography>
                    </VuiBox>
                  </VuiBox>

                  {/* Toggle Buttons */}
                  <ToggleButtonGroup
                    value={viewMode}
                    exclusive
                    onChange={handleViewChange}
                    sx={{
                      backgroundColor: "rgba(0, 0, 0, 0.3)",
                      borderRadius: "12px",
                      padding: "4px",
                    }}
                  >
                    <ToggleButton
                      value="live"
                      sx={{
                        color: "rgba(255, 255, 255, 0.7)",
                        backgroundColor: "rgba(255, 255, 255, 0.05)",
                        border: "1px solid rgba(255, 255, 255, 0.1)",
                        borderRadius: "10px !important",
                        padding: "10px 20px",
                        textTransform: "none",
                        fontWeight: "bold",
                        transition: "all 0.3s ease",
                        "&.Mui-selected": {
                          background: "linear-gradient(97.89deg, #0075ff, #0075ff)",
                          color: "white",
                          border: "1px solid rgba(67, 24, 255, 0.5)",
                          "&:hover": {
                            background: "linear-gradient(97.89deg, #0075ff, #0075ff)",
                          },
                        },
                        "&:hover": {
                          backgroundColor: "rgba(255, 255, 255, 0.15)",
                          color: "white",
                        },
                      }}
                    >
                      <IoPersonOutline size="18px" style={{ marginRight: "8px" }} />
                      Live System
                    </ToggleButton>
                    <ToggleButton
                      value="demo"
                      sx={{
                        color: "rgba(255, 255, 255, 0.7)",
                        backgroundColor: "rgba(255, 255, 255, 0.05)",
                        border: "1px solid rgba(255, 255, 255, 0.1)",
                        borderRadius: "10px !important",
                        padding: "10px 20px",
                        textTransform: "none",
                        fontWeight: "bold",
                        transition: "all 0.3s ease",
                        "&.Mui-selected": {
                          background: "linear-gradient(97.89deg, #0075ff, #0075ff)",
                          color: "white",
                          border: "1px solid rgba(67, 24, 255, 0.5)",
                          "&:hover": {
                            background: "linear-gradient(97.89deg, #0075ff, #0075ff)",
                          },
                        },
                        "&:hover": {
                          backgroundColor: "rgba(255, 255, 255, 0.15)",
                          color: "white",
                        },
                      }}
                    >
                      <IoVideocam size="18px" style={{ marginRight: "8px" }} />
                      Video Demo
                    </ToggleButton>
                  </ToggleButtonGroup>
                </VuiBox>

                {/* Content Container */}
                <VuiBox
                  sx={{
                    width: "100%",
                    height: "calc(100vh - 250px)",
                    borderRadius: "12px",
                    overflow: "hidden",
                    background: viewMode === "live" ? "#0a0e23" : "#000",
                    transition: "background 0.3s ease",
                  }}
                >
                  {viewMode === "live" ? (
                    <iframe
                      src={IFRAME_URL}
                      title="Fall Detection Dashboard"
                      style={{
                        width: "100%",
                        height: "100%",
                        border: "none",
                        borderRadius: "12px",
                      }}
                      allow="camera; microphone; fullscreen; accelerometer; gyroscope; magnetometer"
                      sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-modals"
                    />
                  ) : (
                    <video
                      src="/fall-detection-demo.mp4"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                      }}
                      controls
                      title="Fall Detection Demo Video"
                    >
                      Your browser does not support the video tag.
                    </video>
                  )}
                </VuiBox>
              </Card>
            </Grid>
          </Grid>
        </VuiBox>
      </VuiBox>
      <Footer />
    </DashboardLayout>
  );
}

export default FallDetection;



